/**
 * Identity of the active event set. Order-independent so a realtime miss can be
 * detected by comparing a fresh read with the set last folded into generation.
 */
export function tournamentEventStreamToken(
  events: Array<{ id?: string | null; is_deleted?: boolean | null }>,
): string {
  return events
    .filter((event) => !event.is_deleted && event.id)
    .map((event) => event.id as string)
    .toSorted()
    .join(",");
}
